import React from "react";
import cns from "classnames";
import { darken, transparentize } from "polished";
import { ThemeType } from "@theme";
import BaseButton, { BaseIconButtonProps } from "./BaseIconButton";
import { makeStyles } from "@material-ui/core/styles";

export function SecondaryButton(props: BaseIconButtonProps) {
  const classes = useStyles({});
  const { children, className, ...other } = props;

  return (
    <BaseButton className={cns(classes.root, className)} variant="contained" {...other}>
      {children}
    </BaseButton>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrast,

    "&:hover, &:active": {
      backgroundColor: darken(0.1, theme.palette.secondary.main)
    },

    "&:disabled": {
      backgroundColor: transparentize(0.8, darken(0.1, theme.palette.secondary.main))
    }
  }
}));

export default SecondaryButton;
